import React from 'react';
import { CurlySeduccion } from './pages/CurlySeduccion';
type AppProps = {
  showTestimonials?: boolean;
  showStickyCta?: boolean;
};
export function App({
  showTestimonials = true,
  showStickyCta = true
}: AppProps) {
  return <CurlySeduccion showTestimonials={showTestimonials} showStickyCta={showStickyCta} data-id="element-0" data-mp="3k89qtprxcngb" />;
}